import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IHeaderButton } from '../../interfaces/INavItem.interface';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() buttons: IHeaderButton[] | undefined;
  @Input() showBackButton = false;
  @Input() sidebarOpen = false;
  @Output() backClick = new EventEmitter<void>();
  @Output() menuClick = new EventEmitter<void>();
}
